import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsProductElementComponent extends Component {
  // Functions
  reorderProductTracks = (tracks) => {
    tracks.forEach((track, index) => {
      track.number = index + 1;
    });

    this.args.model.productTracks = tracks;
  };

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            <fieldset.field @disabled={{true}} @property='name' />

            <fieldset.field
              @filters={{hash type='CONFIGURATION'}}
              @property='category'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>
        </div>

        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='productTracks' as |fieldset|>
            <fieldset.field
              @property='productTracks'
              @type='has-many'
              @hasManyReorderItems={{this.reorderProductTracks}}
              @hasManySortableColumn='number'
              @on={{hash openRecordList=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
